// extracted by mini-css-extract-plugin
export var aiStarIcon = "_mb-2";
export var container = "_mb-4";
export var dismissButton = "_mb-3";
export var hasPaddingBottom = "_mb-6";
export var last = "_mb-e";
export var scrollbarThumb = "_mb-c";
export var scrollbarTrack = "_mb-b";
export var selected = "_mb-9";
export var spin = "_mb-1";
export var spinning = "_mb-0";
export var suggestionItem = "_mb-d";
export var suggestionsPanel = "_mb-5";
export var tonePill = "_mb-8";
export var tonesContainer = "_mb-7";
export var unselected = "_mb-a";